const moduleName = 'axisCharts';

import {components, reducers} from 'linksoft';

import axisCharts from './axis-charts';
import reducer from './reducer';

components.add('axis-charts', axisCharts);

reducers.add(moduleName, reducer);

export default {
    name: moduleName,
    containers: [axisCharts],
    reducer: reducer
};


// WEBPACK FOOTER //
// ./App/components/modules/charts/index.js